module.exports = __webpack_public_path__ + "img/lageplan_640.f0efeeb6.webp";